/*
*  CONSTANTS
 * FAVOURITE SECTION CONSTANTS
 *  TOOLS ICONS CONSTANTS
 * TRASH CONSTANTS
 * COLLABORATORS CONSTANTS
 * CARD ITEM CONSTANTS
 * SINGLE PROJECT CONSTANTS
 * WORKSPACE CONSTANTS
 * CURRENCY CONSTANTS
*/

/*
 *  CONSTANTS
*/

/*
 * WORKSPACE CONSTANTS
*/
const WsDropdownCommon = {
  profile: true,
  restore: true,
  permanentlyDelete: true,
  manageAccess: true,
  removeAccess: true,
  newFolder: true,
  newJobs: true,
  preferences: true,
  logout: true,
  open: true,
  addToFollow: true,
  makeItPublic: true
};

export const WsDropdownConstant = {
  emptyRow: {
    name: '',
    id: '',
    workspace: '',
    project: '',
    lastUpdated: 0,
    lastUpdatedBy: {
      id: '',
      name: '',
      surname: '',
      thumbnail: '',
      workspaces: [],
      company_name:''
    },
    shared: true,
    sharedWith: [],
    makeItPublic: true
  },
  dropdownItemPersonal: {
    profile: true,
    share: true,
    manageCollaborators: true,
    restore: true,
    permanentlyDelete: true,
    manageAccess: true,
    removeAccess: true,
    changeColor: true,
    settings: true,
    newProject: true,
    newFolder: true,
    newJobs: true,
    preferences: true,
    logout: true,
    addToFollow: true,
    makeItPublic: true
  },
  dropdownWsPersonal: {
    share: true,
    moveTo: true,
    manageCollaborators: true,
    changeColor: true,
    ...WsDropdownCommon
  },
  dropdownItemShared: {
    changeColor: true,
    settings: true,
    newProject: true,
    ...WsDropdownCommon,
  },
  dropdownWsShared: {
    moveTo: true,
    changeColor: true,
    ...WsDropdownCommon
  },
  swSingleTableHead: [
    {
      colName: 'NAME',
      isSortable: true
    },
    {
      colName: 'COLLABORATORS',
      isSortable: false
    },
    {
      colName: 'ACTIVITY',
      isSortable: false
    },
    {
      colName: '',
      isSortable: false
    },
  ],
  wsTableHead: [
    {
      colName: 'Name',
      isSortable: true
    },
    {
      colName: 'Project',
      isSortable: false
    },
    {
      colName: 'Collaborators',
      isSortable: false
    },
    {
      colName: 'Activity',
      isSortable: false
    },
    {
      colName: '',
      isSortable: false
    },
  ],
  modalDataWs: {
    name: 'New Workspace',
    type: 'workspace',
    buttonName: 'Create',
    collaborators: [],
    is_new: 'true',
    id_entity: null
  },
  modalDataPj: {
    name: 'New Project',
    type: 'project',
    buttonName: 'Create',
    is_new: 'true',
  },
};

/*
 * SINGLE PROJECT CONSTANTS
*/
export const SingleProjectConstant = {
  profile: true,
  open: true,
  restore: true,
  manageAccess: true,
  removeAccess: true,
  permanentlyDelete: true,
  changeColor: true,
  settings: true,
  newProject: true,
  preferences: true,
  addToFavourite: false,
  logout: true,
  makeItPublic: true
};

/*
 * CARD ITEM CONSTANTS
*/
export const CardItemCommon = {
  profile: true,
  restore: true,
  permanentlyDelete: true,
  manageAccess: true,
  removeAccess: true,
  changeColor: true,
  newProject: true,
  newFolder: true,
  newJobs: true,
  settings: true,
  preferences: true,
  logout: true,
  addToFollow: true,
  addToFavourite: false,
};

/*
 * COLLABORATORS CONSTANTS
 */
const CollaboratorsDropdownCommon = {
  open: true,
  restore: true,
  moveTo: true,
  rename: true,
  share: true,
  manageCollaborators: true,
  addToFavourite: true,
  permanentlyDelete: true,
  changeColor: true,
  settings: true,
  newProject: true,
  newFolder: true,
  newJobs: true,
  preferences: true,
  logout: true,
  addToFollow: true,
  makeItPublic: true
};

export const CollaboratorsDropdownConstant = {
  dropdownAdmin: {
    removeAccess: true,
    ...CollaboratorsDropdownCommon
  },
  dropdownProfile: {
    manageAccess: true,
    removeAccess: true,
    delete: true,
    ...CollaboratorsDropdownCommon
  },
  dropdownProfileAndRemove: {
    manageAccess: true,
    delete: true,
    ...CollaboratorsDropdownCommon
  },  
  theadAdmin: [
    {
      colName: 'NAME',
      isSortable: true
    },
    {
      colName: 'ORGANIZATION',
      isSortable: true
    },
    {
      colName: 'ROLE',
      isSortable: true
    },
    {
      colName: 'JOB',
      isSortable: true
    },
    {
      colName: 'ACCESS',
      isSortable: false
    },
    {
      colName: '',
      isSortable: false
    },
  ],
  theadAll: [
    {
      colName: 'NAME',
      isSortable: true
    },
    {
      colName: 'ROLE',
      isSortable: true
    },
    {
      colName: 'ACCESS',
      isSortable: false
    },
    {
      colName: '',
      isSortable: false
    },
  ],
  theadAllCollaborators: [
    {
      colName: 'NAME',
      isSortable: true
    },
    {
      colName: 'ROLE',
      isSortable: true
    },
    {
      colName: 'JOB',
      isSortable: true
    },
    {
      colName: '',
      isSortable: false
    },
  ]
 
};
/*
 * ORGANIZATIONS CONSTANTS
 */
export const OrganizationConstant = {
  dropdown: {
    profile: true,
    open: true,
    share: true,
    moveTo: true,
    addToFavourite: true,
    manageCollaborators: true,
    manageAccess: true,
    removeAccess: true,
    changeColor: true,
    settings: true,
    delete: true,
    newProject: true,
    newFolder: true,
    newJobs: true,
    preferences: true,
    logout: true,
    addToFollow: true,
    makeItPublic: true,
    restore:true,
    permanentlyDelete:true
    
  },
  thead: [
    {
      colName: 'NAME',
      isSortable: true
    },  
    {
      colName: '',
      isSortable: false
    }
  ]
};

/*
 * TRASH CONSTANTS
 */
export const TrashConstant = {
  dropdown: {
    profile: true,
    open: true,
    share: true,
    moveTo: true,
    rename: true,
    addToFavourite: true,
    manageCollaborators: true,
    manageAccess: true,
    removeAccess: true,
    changeColor: true,
    settings: true,
    delete: true,
    newProject: true,
    newFolder: true,
    newJobs: true,
    preferences: true,
    logout: true,
    addToFollow: true,
    makeItPublic: true
  },
  thead: [
    {
      colName: 'NAME',
      isSortable: true
    },
    {
      colName: 'TYPE',
      isSortable: true
    },
    {
      colName: 'OWNER',
      isSortable: false
    },
    {
      colName: 'DATA',
      isSortable: false
    },
    {
      colName: '',
      isSortable: false
    },
  ]
};

/*
 * FAVOURITE SECTION CONSTANTS
 */
const FavouriteSectionDropdownCommon = {
  profile: true,
  restore: true,
  permanentlyDelete: true,
  manageAccess: true,
  removeAccess: true,
  changeColor: true,
  settings: true,
  newProject: true,
  newFolder: true,
  newJobs: true,
  preferences: true,
  logout: true,
  addToFollow: true
};

export const FavouriteSectionConstant = {
  dropdownPersonal: {
    share: true,
    manageCollaborators: true,
    makeItPublic: true,
    ...FavouriteSectionDropdownCommon
  },
  dropdownShared: {
    makeItPublic: true,
    ...FavouriteSectionDropdownCommon
  },
  dropdownFolder: {
    share: true,
    manageCollaborators: true,
    makeItPublic: true,
    ...FavouriteSectionDropdownCommon
  },
  dropdownExecution: {
    share: true,
    manageCollaborators: true,
    ...FavouriteSectionDropdownCommon
  },
  thead: [
    {
      colName: 'Name',
      isSortable: true
    },
    {
      colName: 'Status',
      isSortable: true
    },
    {
      colName: 'Collaborators',
      isSortable: false
    },
    {
      colName: 'Activity',
      isSortable: false
    },
    {
      colName: '',
      isSortable: false
    },
  ]
};

/*
 *  TOOLS ICONS CONSTANTS

export enum ToolsIcon {
  ESG = 'assets/images/tool_ESG.svg',
  GS = 'assets/images/tool_GS.svg',
  NLL = 'assets/images/tool_NLL.svg',
  NLS = 'assets/images/tool_NLS.svg',
  Test = 'assets/images/test_tool.svg'
}
export enum ToolsCompletedName {
  ESG = 'ESG',
  GS = 'GS',
  NLL = 'Non-Life (local)',
    NLS = 'Non-Life (solvency)',
  Test = 'CI'
}*/

/*
 *  NUMBER REGEX
 */
export const numberRegex = '^\\d*[0-9](|.\\d*[0-9]|,\\d*[0-9])?$';
export const tableNumberRegex = '^-?\\d*[0-9](|.\\d*[0-9]|,\\d*[0-9])?$';
export const yearRegex = '^[0-9]{4}$';

/*
 *  EMAIL REGEX
 */

// tslint:disable-next-line: max-line-length
export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
